import { useMemo } from 'react'
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react'
import { isProduction, isSandbox, isTest } from 'utils/environment'

type Flow = 'LOGIN'
interface FingerprintProps {
  flow?: Flow
  merchantName: string
  accountId: number
  profileId: number
}

export const useFingerprint = ({
  merchantName,
  accountId,
  profileId,
  flow = 'LOGIN',
}: FingerprintProps) => {
  const enableFingerprint = useMemo(
    () => !!flow && !!merchantName && !!accountId && !!profileId,
    [flow, merchantName, accountId, profileId]
  )

  const { isLoading, error, data } = useVisitorData(
    {
      extendedResult: true,
      tag: {
        source: 'BVNK Merchant Portal',
        flow,
        merchantName,
        accountId,
      },
    },
    { immediate: enableFingerprint && (isSandbox || isProduction || isTest) }
  )

  return { isLoading, error, data }
}
